import { jsx as M } from "react/jsx-runtime";
import { BadRequest as P } from "@systemeio/util";
import { useStore as x } from "../../../../store/index.mjs";
import { useStripeApi as b } from "../../api/stripe-api.mjs";
import { getStripeCardConfirmHandler as g } from "../utils/get-stripe-card-confirm-handler.mjs";
import { useStripe as k, useElements as q, ExpressCheckoutElement as B } from "../../../../node_modules/@stripe/react-stripe-js/dist/react-stripe.esm.mjs";
import { PaymentMethodEnum as F } from "@systemeio/ui";
import { useRollbar as H } from "@rollbar/react";
function T({
  setIsFetching: a,
  handleBadRequest: f,
  setErrors: c,
  preSubmit: l
}) {
  const r = k(), t = q(), y = H(), { locale: d } = x(), { stripeCardBuyOffer: u, confirmPaymentIntent: h } = b();
  return /* @__PURE__ */ M(
    B,
    {
      options: {
        paymentMethods: {
          applePay: "always",
          googlePay: "never",
          amazonPay: "never",
          link: "never",
          paypal: "never"
        }
      },
      onConfirm: async (o) => {
        if (!(!r || !t)) {
          a(!0);
          try {
            const e = l();
            if (!e) return;
            const { error: w } = await t.submit();
            if (w) {
              o.paymentFailed();
              return;
            }
            const { error: C, paymentMethod: n } = await r.createPaymentMethod({
              elements: t
            });
            if (C || !n) {
              o.paymentFailed();
              return;
            }
            const { redirect: i, intentSecret: m, intentType: E } = await u(
              {
                ...e,
                paymentMethod: F.stripe_applepay,
                options: { stripePaymentMethodId: n.id }
              },
              d
            );
            if (!m) return window.location.href = i;
            const S = g(r, E), { error: s } = await S(m, {
              payment_method: n.id
            });
            s ? c((p) => ({
              ...p,
              common: [...p.common, s.message]
            })) : (await h(), window.location.assign(i));
          } catch (e) {
            try {
              o.paymentFailed({ reason: "fail" });
            } catch {
            }
            e instanceof P ? f(e) : y.error("Stripe Express Checkout Confirmation Error", { error: e });
          } finally {
            a(!1);
          }
        }
      }
    }
  );
}
export {
  T as StripeExpressCheckout
};
